import { observer } from "owa-mobx-react";
import React from "react";
import classnames from "owa-classnames";
import { createPortal } from "owa-react-dom";
import { type AppPaneUnderlayViewState, isAppPaneUnderlayExpanded, isAppPaneUnderlayPlaceholder, isAppPaneUnderlayShrinkable, } from "owa-app-pane-underlay";
import { underlay as underlayClass, shrinkable, placeholder } from "./AppPaneUnderlay.scss";

export interface AppPaneUnderlayProps {
    underlay: AppPaneUnderlayViewState | undefined;
    mountNode?: HTMLElement | null;
    /**
     * Inline style applied to the underlay when it is portaled under the ribbon for
     * the add-in drawer. `AppPaneUnderlay` is a shared component, so the under-ribbon
     * layout (flex order, and the 8px top gap for the Copilot-disabled main-window
     * fallback) is computed by the owning `App` and passed in rather than hardcoded
     * here.
     */
    underlayStyle?: React.CSSProperties;
}

const AppPaneUnderlay: React.FunctionComponent<AppPaneUnderlayProps> = observer(function AppPaneUnderlay({ underlay, mountNode, underlayStyle }: AppPaneUnderlayProps) {
    const underlayInlineStyle = mountNode ? underlayStyle : undefined;
    const underlayElement = isAppPaneUnderlayExpanded(underlay) ? (<div style={underlayInlineStyle} className={classnames(underlayClass, isAppPaneUnderlayShrinkable(underlay) && shrinkable, isAppPaneUnderlayPlaceholder(underlay) && placeholder)}/>) : null;
    
    // When anchored to a mountNode (add-in drawer under the ribbon), portal the
    // underlay into that flex-row container so it becomes a flex sibling that
    // reserves the drawer's width and pushes the reading pane aside.
    if (mountNode && underlayElement) {
        return createPortal(underlayElement, mountNode);
    }
    
    return underlayElement;
}, "AppPaneUnderlay");

export default AppPaneUnderlay;
